import { CdkMenuModule } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { PalantirAvatarComponent } from '../../../../avatar/avatar.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import type { PalantirIcon } from '../../../../icon/icon.type';
import { PalantirTextComponent } from '../../../../text/text.component';
import { PalantirTooltipModule } from '../../../../tooltip/tooltip.module';

@Component({
  selector: 'palantir-table-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CdkMenuModule,
    PalantirTextComponent,
    PalantirAvatarComponent,
    PalantirIconComponent,
    PalantirTooltipModule,
  ],
})
export class PalantirTableAvatarComponent {
  @Input() public value?: string;

  @Input() public label?: string;

  @Input() public icon?: PalantirIcon;

  @Input() public clickable: boolean = false;

  @HostBinding('class.clickable')
  public get isClickable(): boolean {
    return this.clickable;
  }
}
